<template>
  <div class="operation_log_class">
    <a-form :form="form" layout="inline" class="productHeadForm" style="margin-top: 10px;">
      <a-form-item label="配方">
        <a-input
          v-decorator="['formulaKeyword']"
          @pressEnter="getList({current:1,pageSize:pagination.pageSize})"
          placeholder="配方名称/代码"
        />
      </a-form-item>
      <!-- <a-form-item label="产品">
        <a-input
          v-decorator="['productKeyword']"
          @pressEnter="getList({current:1,pageSize:pagination.pageSize})"
          placeholder="产品名称/编码"
        />
      </a-form-item> -->
      <a-form-item label="工厂">
        <a-input
          v-decorator="['factoryName']"
          @pressEnter="getList({current:1,pageSize:pagination.pageSize})"
          placeholder="工厂名称"
        />
      </a-form-item>
      <a-form-item label="品管">
        <a-input
          v-decorator="['qcManager']"
          @pressEnter="getList({current:1,pageSize:pagination.pageSize})"
          placeholder="品管姓名"
        />
      </a-form-item>
      <a-form-item label="营养师">
        <a-input
          v-decorator="['staffName']"
          @pressEnter="getList({current:1,pageSize:pagination.pageSize})"
          placeholder="营养师姓名"
        />
      </a-form-item>
      <a-form-item label="EBS执行时间">
        <a-range-picker
          style="width: 180px;"
          v-decorator="['ebsExecTime']"
          @pressEnter="getList({current:1,pageSize:pagination.pageSize})"
        />
      </a-form-item>
      <a-form-item label="NHF推送时间">
        <a-range-picker
          style="width: 180px;"
          v-decorator="['formulaPushTime']"
          @pressEnter="getList({current:1,pageSize:pagination.pageSize})"
        />
      </a-form-item>
      <a-form-item>
        <a-space>
          <a-button type="primary" @click="getList">查询</a-button>
          <a-button @click="clear">清空</a-button>
        </a-space>
      </a-form-item>
    </a-form>
    <a-table ref="listRef" :columns="columns" :data-source="list"  class="tableBox" :pagination="pagination" :scroll="{y,x: 100}" row-key="id">
      <template slot="name" slot-scope="text">
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{text}}</span>
          </template>
          {{text}}
        </a-tooltip>
      </template>
      <template slot="x" slot-scope="t,r">
        <a-button type="link" @click="() => viewData(r)">查看</a-button>
      </template>
    </a-table>
    <view-data-modal :viewVisible="viewVisible" :rowData="rowData" @close="closeView" />
  </div>
</template>

<script>
import {EBSColumns} from './columns';
import {mapMutations} from 'vuex'
import api from './api'
import ViewDataModal from './FormulaComponents/ViewDataModal.vue'
import moment from 'moment';
export default {
  components: {ViewDataModal},
  props: [],
  data() {
    return {
      form: this.$form.createForm(this),
      columns: EBSColumns,
      y: 500,
      list: [],
      rowData: {},
      viewVisible: false,
      pagination: {
        total:0,
        pageSize:20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条数据`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.y = this.$refs.listRef.offsetHeight - 116
    this.getList()
  },
  methods: {
    ...mapMutations('product',['setState']),
    closeView(){
      this.rowData = {}
      this.viewVisible = false
    },
    async getList(pagination){
      let {pageSize: size=20,current=1} = pagination || this.pagination
      this.form.validateFields(async (err,values) => {
        let {ebsExecTime,formulaPushTime,...newValues} = values || {}
        let params = {
          query: {size,current},
          formulaPushTimeStart: formulaPushTime ? moment(formulaPushTime[0]).format('YYYY-MM-DD 00:00:00') : undefined,
          formulaPushTimeEnd: formulaPushTime ? moment(formulaPushTime[1]).format('YYYY-MM-DD 23:59:59') : undefined,
          ebsExecTimeStart: ebsExecTime ? moment(ebsExecTime[0]).format('YYYY-MM-DD 00:00:00') : undefined,
          ebsExecTimeEnd: ebsExecTime ? moment(ebsExecTime[1]).format('YYYY-MM-DD 23:59:59') : undefined,
          ...newValues,
          factoryId: window.localStorage.getItem('factoryId'),
          staffId: window.localStorage.getItem('staffId'),
        }
        let res = await api.getEBSList(params)
        let {data} = res || {}
        let {records} = data || {};
        this.pagination.current = data.current
        this.pagination.total = data.total
        this.list = records || []
      })
    },
    clear(){
      this.form.resetFields();
    },
    viewData(rowData){
      this.rowData = rowData
      this.viewVisible = true
    },
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped>
.productHeadForm{
  border-radius: 5px;
  margin-bottom: 20px;
  padding: 10px 20px;
  background-color: #fff;
  .ant-form-inline .ant-form-item > .ant-form-item-control-wrapper, .ant-form-inline .ant-form-item > .ant-form-item-label{
    vertical-align: middle;
  }
}
</style>